(function ($, Headroom) {
  'use strict';

  var headroom;

  $(document).ready(init);

  function init() {
    var blockProductNav = document.querySelector('.block-product-nav');
    if (blockProductNav) {
      $('.block-product-nav__item-link', blockProductNav).each(function () {
        var target = $(this).attr('href');

        if (!$(target).length) {
          $(this).closest('.block-product-nav__item').remove();
        }
      });

      headroom = new Headroom(blockProductNav, {
        offset: blockProductNav.getBoundingClientRect().top + window.pageYOffset,
        tolerance: 12,
        classes: {
          initial: 'block-product-nav--pinnable',
          pinned: 'block-product-nav--pinned',
          unpinned: 'block-product-nav--unpinned',
          top: 'block-product-nav--top',
          notTop: 'block-product-nav--not-top',
          bottom: 'block-product-nav--bottom',
          notBottom: 'block-product-nav--not-bottom'
        }
      });
      headroom.init();
    }
  }

})(jQuery, Headroom);
